const LOGIN_PATH = '/auth/login';
const SIGNIN_COMPAT_PATH = '/signin';
const LOCALE_PREFIX_RE = /^\/(?:en|ar)(?=\/|$)/;

function stripLocalePrefix(path: string) {
  return path.replace(LOCALE_PREFIX_RE, '') || '/';
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.auth === false || to.matched.length === 0) return;

  const pathWithoutLocale = stripLocalePrefix(to.path);
  if (pathWithoutLocale === LOGIN_PATH || pathWithoutLocale === SIGNIN_COMPAT_PATH) return;

  const { status, getSession } = useAuth();

  if (status.value !== 'authenticated') {
    try {
      await getSession();
    } catch {
      // Treat session lookup errors as unauthenticated and send the user to login.
    }
  }

  if (status.value === 'authenticated') return;

  const localePath = useLocalePath();
  const callbackUrl = pathWithoutLocale === '/' ? localePath('/your-work') : to.fullPath;

  return navigateTo(
    {
      path: localePath(LOGIN_PATH),
      query: { callbackUrl },
    },
    { replace: true },
  );
});
